var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTaskFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    viewBox: "0 0 34 35",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 8.63477h16v17.2584h-16z",
    fill: "#000",
    opacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.6641,
    fill: "#dadbdd",
    r: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.5992 16.9487v1.8249h-3.148c-.9638 0-1.752.8451-1.752 1.8876v1.8876h12.6v-1.8875c0-1.0498-.7844-1.8877-1.752-1.8877h-3.148v-1.8251c1.2347-.5829 2.1-1.9129 2.1-3.4603 0-2.0807-1.567-3.77531-3.5-3.77531-1.9291 0-3.5 1.69031-3.5 3.77531 0 1.5449.8639 2.877 2.1 3.4605zm7.0001 6.354h-11.1999v1.5101h11.1999z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskFinished);
export default __webpack_public_path__ + "static/media/icon-task-finished.7bbcd631eb77db828513cc79f6df4b4e.svg";
export { ForwardRef as ReactComponent };